import { computed, ref } from "vue"

/** Options du fetch : ne pas activer l’état global `isFetching` (rafraîchissement en arrière-plan). */
export type UseFetchWrapperFetchMeta = {
    silent?: boolean
}

/**
 * Fonction utilitaire pour fetch des appel API.
 * Renvoie la fonction de fetch et des états de chargement
 * @returns
 */
export const useFetchWrapper = (
    callback: (kwargs?: any, controller?: AbortController) => Promise<void>,
    callbackError?: (error: Error) => void
) => {
    const fetching = ref(false)

    const isSuccess = ref(false)
    const error = ref<(Error & { code?: string }) | null>(null)

    let controller = new AbortController()

    function cancel() {
        fetching.value = false
        isSuccess.value = false
        error.value = null
        controller.abort()
    }

    const fetch = async (
        kwargs?: unknown,
        fetchMeta?: UseFetchWrapperFetchMeta
    ) => {
        const silent = fetchMeta?.silent === true
        if (!silent) {
            fetching.value = true
        }
        isSuccess.value = false
        error.value = null
        controller = new AbortController()
        try {
            await callback(kwargs, controller)
            isSuccess.value = true
        } catch (err) {
            const innerError = err as Error & { code?: string }
            error.value = innerError
            if (callbackError) callbackError(innerError)
        } finally {
            if (!silent) {
                fetching.value = false
            }
        }
    }

    const hasError = computed(() => !!error.value)

    const isFetching = computed(() => fetching.value)

    return {
        isFetching,
        hasError,
        isSuccess,
        fetch,
        error,
        cancel,
    }
}
